/* eslint-disable prettier/prettier */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import { getOneClient } from '../../../../../../redux/fetchActions/legadoPage/clientsApp';
import SearchButton from '../../../../../../shared/components/buttons/SearchButton';
import Filter from '../../../../../../shared/components/Filter';
import SetClientSearch from './components/SetClientSearch';

export function ClientOneFilter() {
  const dispatch = useDispatch();

  const clientsFilterState = useSelector(
    (reducer: IReducer) => reducer.clientsFilter
  );
 
  const profileNivelState = useSelector(
    (reducer: IReducer) => reducer.partnerProfile
  );

  function searchFare() {
    dispatch(
      getOneClient(profileNivelState.idLegado, clientsFilterState.account)
    );
  }

  return (
    <Filter.Default>
      <SetClientSearch />
      <SearchButton
        onClick={() => searchFare()}
        justifyContent="center"
        width="10rem"
      />
    </Filter.Default>
  );
}

export default ClientOneFilter;
